import { shape, string, arrayOf } from 'prop-types';

const listingTypeShape = shape({
    excludedFilters: arrayOf(string),
});

export default shape({
    category: listingTypeShape,
    brand: listingTypeShape,
    vp: listingTypeShape,
    search: listingTypeShape,
    mandatoryFilters: arrayOf(string),
});
